import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { setTaskAnswerToDeleteId } from '../../../store/adminSlices/rallies';
const ConfirmDeleteTaskAnswer = ({ answerId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const deleteAnswer = async () => {
        dispatch(setTaskAnswerToDeleteId(answerId));
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
    };
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.confirm_delete_answer'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            } }), _jsx(Button, { variant: 'outlined', label: t('button.delete_answer'), onClick: deleteAnswer })] }) })] }));
};
export default ConfirmDeleteTaskAnswer;
